export default [
    'Comprehensive Eye Exam',
    'Pediatric Vision Care',
    'Myopia Management',
    'Contact Lens Services',
    'Binocular Vision Therapy',
    'Ocular Disease Screening',
    'Dry Eye Management',
    'Low Vision Care',
    'Geriatric Eye Care',
    'Spectacle and Contact Lens Services'
];
